import { RotateCcw } from 'lucide-react';
import type { BookingCancellationUnfinishedOperation } from '@/shared/api';

/**
 * Ein früherer Stornoversuch dieser Buchung ist offen — meist, weil das Apartment gerade an
 * Channex übertragen wurde. Der Dialog setzt genau ihn fort; was schon geschehen ist, steht hier.
 */
export function UnfinishedCancellationNotice({
  operation,
}: {
  operation: BookingCancellationUnfinishedOperation;
}) {
  return (
    <p
      role="status"
      className="border-amber/40 bg-amber-soft text-ink flex gap-2 rounded-md border p-3 text-sm"
    >
      <RotateCcw className="text-gold mt-0.5 size-4 shrink-0" aria-hidden />
      <span>
        {operation.paymentDispositionAccepted
          ? 'Ein früherer Stornoversuch hat die Zahlung schon erledigt (erstattet oder geschlossen); die Buchung ist aber noch aktiv. Abschließen storniert sie, ohne erneut zu erstatten.'
          : 'Ein früherer Stornoversuch wurde nicht abgeschlossen. Abschließen setzt ihn mit derselben Entscheidung fort.'}
      </span>
    </p>
  );
}
